module.exports = __webpack_public_path__ + "img/calculate-black-24-dp.8c712b16.svg";